function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../logger';
import { cloneAdBreak } from '../../utils/ad-break-utils';
import { checkIsManifestLinearType } from '../../utils/playback-type';
export var AdBreakTimeAdapter = /*#__PURE__*/ function() {
    "use strict";
    function AdBreakTimeAdapter(playbackType) {
        var _this = this;
        _class_call_check(this, AdBreakTimeAdapter);
        _define_property(this, "playbackType", void 0);
        _define_property(this, "computedBreaks", void 0);
        _define_property(this, "isCurrentlyInAdBreak", void 0);
        _define_property(this, "adBreakPositionIncludingAdsToContentPosition", void 0);
        _define_property(this, "adBreakContentPositionToPositionIncludingAds", void 0);
        this.playbackType = playbackType;
        this.computedBreaks = [];
        this.isCurrentlyInAdBreak = function(timeIncludingAds) {
            var prevBreaks = _this.computedBreaks.filter(function(adBreak) {
                return adBreak.start <= timeIncludingAds;
            });
            if (prevBreaks.length > 0) {
                var mostRecentBreak = prevBreaks[prevBreaks.length - 1];
                if (mostRecentBreak.end > timeIncludingAds) {
                    return true;
                }
            }
            return false;
        };
        this.adBreakPositionIncludingAdsToContentPosition = function(adBreak) {
            var clonedAdBreak = cloneAdBreak(adBreak);
            clonedAdBreak.position = _this.timeIncludingAdsToContentTime(_this.getAdBreakPositionSeconds(adBreak));
            return clonedAdBreak;
        };
        this.adBreakContentPositionToPositionIncludingAds = function(adBreak) {
            var clonedAdBreak = cloneAdBreak(adBreak);
            clonedAdBreak.position = _this.contentTimeToTimeIncludingAds(_this.getAdBreakPositionSeconds(adBreak));
            return clonedAdBreak;
        };
    }
    _create_class(AdBreakTimeAdapter, [
        {
            key: "initialise",
            value: function initialise(receivedAdBreaks) {
                var _this = this;
                var accumulatedBreakDuration = 0;
                this.computedBreaks = receivedAdBreaks.map(function(adBreak) {
                    var start = _this.getAdBreakPositionSeconds(adBreak);
                    var end = start + _this.getAdBreakLengthSec(adBreak);
                    var duration = end - start;
                    var contentTime = start - accumulatedBreakDuration;
                    if (contentTime < 0) {
                        sdkLogger.withContext('AdBreakTimeAdapter').error('Unsorted ad breaks detected! Ad Breaks are expected to be sorted in order of chronological appearance.');
                    }
                    accumulatedBreakDuration += duration;
                    return {
                        start: start,
                        end: end,
                        duration: duration,
                        contentTime: contentTime,
                        accumulatedBreakDuration: accumulatedBreakDuration,
                        originalBreak: adBreak
                    };
                });
            }
        },
        {
            key: "timeIncludingAdsToContentTime",
            value: function timeIncludingAdsToContentTime(timeIncludingAds) {
                if (checkIsManifestLinearType(this.playbackType)) {
                    return timeIncludingAds;
                }
                var seenAdverts = this.computedBreaks.filter(function(adBreak) {
                    return adBreak.start < timeIncludingAds;
                });
                if (seenAdverts.length > 0) {
                    var lastSeenBreak = seenAdverts[seenAdverts.length - 1];
                    if (lastSeenBreak.end > timeIncludingAds) {
                        return lastSeenBreak.contentTime;
                    }
                    return timeIncludingAds - lastSeenBreak.accumulatedBreakDuration;
                }
                return timeIncludingAds;
            }
        },
        {
            key: "contentTimeToTimeIncludingAds",
            value: function contentTimeToTimeIncludingAds(contentTime) {
                if (checkIsManifestLinearType(this.playbackType)) {
                    return contentTime;
                }
                var seenAdverts = this.computedBreaks.filter(function(adBreak) {
                    return adBreak.contentTime < contentTime;
                });
                if (seenAdverts.length > 0) {
                    var lastSeenBreak = seenAdverts[seenAdverts.length - 1];
                    return contentTime + lastSeenBreak.accumulatedBreakDuration;
                }
                return contentTime;
            }
        },
        {
            key: "timeIncludingAdsToAdPosition",
            value: function timeIncludingAdsToAdPosition(timeIncludingAds) {
                var adBreak = this.computedBreaks.find(function(b) {
                    return timeIncludingAds >= b.start && timeIncludingAds <= b.end;
                });
                if (adBreak) {
                    var adBreakPosition = timeIncludingAds - adBreak.start;
                    var accAdDuration = 0;
                    var adPosition = 0;
                    var ad;
                    for(var i = 0; i < adBreak.originalBreak.ads.length; i++){
                        var currentAd = adBreak.originalBreak.ads[i];
                        if (accAdDuration + currentAd.expectedDuration > adBreakPosition) {
                            adPosition = adBreakPosition - accAdDuration;
                            ad = currentAd;
                            break;
                        }
                        accAdDuration += currentAd.expectedDuration;
                    }
                    return {
                        adPosition: adPosition,
                        ad: ad,
                        adBreakPosition: adBreakPosition,
                        adBreak: adBreak.originalBreak
                    };
                }
            }
        },
        {
            key: "getAdBreakLengthSec",
            value: function getAdBreakLengthSec(adBreak) {
                var _adBreak_expectedDuration;
                return (_adBreak_expectedDuration = adBreak.expectedDuration) !== null && _adBreak_expectedDuration !== void 0 ? _adBreak_expectedDuration : adBreak.ads.reduce(function(breakDuration, ad) {
                    return breakDuration + ad.expectedDuration;
                }, 0);
            }
        },
        {
            key: "getAdBreakPositionSeconds",
            value: function getAdBreakPositionSeconds(adBreak) {
                return typeof adBreak.position === 'number' ? adBreak.position : 0;
            }
        }
    ]);
    return AdBreakTimeAdapter;
}();

//# sourceMappingURL=ad-break-time-adapter.js.map